import * as yup from 'yup'
import { t } from 'i18next'

const shareObjectValidate = yup.object().shape({
    employee_id: yup
        .array()
        .of(yup.number())
        .test(
            'employee-or-department-required',
            t('drive.shareModal.select-employee-or-department') as string,
            function () {
                const { employee_id, department_id } = this.parent || {}
                const hasEmployee =
                    Array.isArray(employee_id) && employee_id.length > 0
                const hasDepartment =
                    Array.isArray(department_id) && department_id.length > 0
                return hasEmployee || hasDepartment
            }
        ),
    department_id: yup.array().of(yup.number()),
    permission_level: yup
        .string()
        .required(t('drive.shareModal.select-permission') as string),
})

export default shareObjectValidate
